"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _index = _interopRequireDefault(require("@insided/deprecated-preact-components/client-component/index.server"));

var _SearchForm = _interopRequireDefault(require("../../Search/Features/SearchWidget/SearchForm"));

var _UserContext = require("@insided/shared/services/UserContext");

var _classnames = _interopRequireDefault(require("classnames"));

var _getWidgetStyle = require("@insided/deprecated-preact-components/utils/getWidgetStyle");

var _SearchForm2 = _interopRequireDefault(require("@insided/deprecated-preact-components/algolia/components/SearchForm"));

var getContentClassnames = function getContentClassnames(centered) {
  if (centered) {
    return {
      container: 'sitewidth',
      title: (0, _classnames.default)('brand-hero-title', 'content--centered', 'qa-brand-hero-title'),
      subtitle: (0, _classnames.default)('brand-hero-subtitle', 'content--centered', 'qa-brand-hero-subtitle'),
      search: 'hero-search'
    };
  }

  return {
    container: (0, _classnames.default)('forum-list-view-spacing', 'forum-list-view-spacing--v', 'qa-subForum-header'),
    title: (0, _classnames.default)('thread-list-view-title', 'brand-hero-title', 'qa-page-title'),
    subtitle: (0, _classnames.default)('forum-list-view-description', 'brand-hero-subtitle', 'qa-subforum-description'),
    search: 'searchbar-in-hero'
  };
};

var GenericHeroContent = function GenericHeroContent(_ref) {
  var centered = _ref.centered,
      title = _ref.title,
      subtitle = _ref.subtitle,
      isFederatedSkilljarSearch = _ref.isFederatedSkilljarSearch,
      isFederatedSalesforceSearch = _ref.isFederatedSalesforceSearch,
      isFederatedFreshdeskSearch = _ref.isFederatedFreshdeskSearch,
      titleColor = _ref.titleColor,
      titleColorDisplay = _ref.titleColorDisplay,
      subtitleColor = _ref.subtitleColor,
      subtitleColorDisplay = _ref.subtitleColorDisplay,
      searchRevamp = _ref.searchRevamp,
      aiSearchSummary = _ref.aiSearchSummary,
      askAISearchSummary = _ref.askAISearchSummary,
      isGuest = _ref.isGuest,
      aiSmartSearchEnableForAllRoles = _ref.aiSmartSearchEnableForAllRoles,
      liveSearchSuggestedQuestions = _ref.liveSearchSuggestedQuestions,
      forethoughtAgent = _ref.forethoughtAgent,
      categories = _ref.categories,
      productAreas = _ref.productAreas;
  var contentClassNames = getContentClassnames(centered);
  var titleStyle = (0, _getWidgetStyle.getTextColorStyle)({
    color: titleColor,
    colorDisplay: titleColorDisplay
  });
  var subtitleStyle = (0, _getWidgetStyle.getTextColorStyle)({
    color: subtitleColor,
    colorDisplay: subtitleColorDisplay
  });
  return (0, _preact.h)(_UserContext.CurrentUserContext.Consumer, null, function (user) {
    return (0, _preact.h)("div", {
      className: contentClassNames.container
    }, (0, _preact.h)("h1", {
      className: contentClassNames.title,
      style: titleStyle
    }, title), subtitle && (0, _preact.h)("p", {
      className: contentClassNames.subtitle,
      style: subtitleStyle
    }, subtitle), (0, _preact.h)("div", {
      className: (0, _classnames.default)(contentClassNames.search, {
        'search-v2': searchRevamp
      })
    }, searchRevamp ? (0, _index.default)(_SearchForm.default, 'destination/modules/Search/Features/SearchWidget/SearchForm', {
      isFederatedSalesforceSearch: isFederatedSalesforceSearch,
      isFederatedSkilljarSearch: isFederatedSkilljarSearch,
      isFederatedFreshdeskSearch: isFederatedFreshdeskSearch,
      searchInContentCategories: categories === null || categories === void 0 ? void 0 : categories.map(function (category) {
        return Number(category);
      }),
      searchInProductAreas: productAreas,
      aiSearchSummary: aiSearchSummary !== null && aiSearchSummary !== void 0 ? aiSearchSummary : false,
      askAISearchSummary: askAISearchSummary !== null && askAISearchSummary !== void 0 ? askAISearchSummary : false,
      isGuest: isGuest,
      aiSmartSearchEnableForAllRoles: aiSmartSearchEnableForAllRoles,
      liveSearchSuggestedQuestions: liveSearchSuggestedQuestions,
      forethoughtAgent: forethoughtAgent,
      // Mirrors hero alignment so the suggested-questions row
      // sits centered under a centered search or starts at the
      // left edge of a left-aligned one.
      centered: centered
    }) : (0, _index.default)(_SearchForm2.default, 'algolia/components/SearchForm', {
      isUserGuest: !user.id,
      isFederatedSalesforceSearch: isFederatedSalesforceSearch,
      isFederatedSkilljarSearch: isFederatedSkilljarSearch,
      isFederatedFreshdeskSearch: isFederatedFreshdeskSearch,
      searchInContentCategories: categories === null || categories === void 0 ? void 0 : categories.map(function (category) {
        return Number(category);
      })
    })));
  });
};

var _default = GenericHeroContent;
exports.default = _default;